window.addEventListener('scroll', function() {
    const fixedBar = document.querySelector('.fixed-pdp-bar');
    const productSubmitWrapper = document.querySelector('.product-submit-wrapper');
    const rect = productSubmitWrapper.getBoundingClientRect();

    if (rect.bottom <= 0) {
      fixedBar.classList.add('active');
    } else {
      fixedBar.classList.remove('active');
    }
});